import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    TextField,
} from "@mui/material";

const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 1,
};

export default function Preferences({
    open,
    handleClose,
    preferences,
    setPreferences,
}) {
    const handleChange = (event) => {
    setPreferences(prev => ({
        ...prev,
        [event.target.name]: event.target.checked,
    }));
    };

    const handleChangeValue = (event) => {
    setPreferences(prev => ({
        ...prev,
        [event.target.name]: event.target.value,
    }));
    };

    const handleBlurUppercase = (fieldName) => () => {
    setPreferences(prev => ({
        ...prev,
        [fieldName]: (prev[fieldName] ?? "").toUpperCase(),
    }));
    };

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={modalStyle}>
                    <FormControl
                        sx={{ m: 3 }}
                        component="fieldset"
                        variant="standard">
                        <FormLabel component="legend">
                            Display Preferences
                        </FormLabel>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={preferences.playerNumbers}
                                        onChange={handleChange}
                                        name="playerNumbers"
                                    />
                                }
                                label="Player Number on Base"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={preferences.stateIndicator}
                                        onChange={handleChange}
                                        name="stateIndicator"
                                    />
                                }
                                label="Data Age Indicators"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={preferences.flashUpdate}
                                        onChange={handleChange}
                                        name="flashUpdate"
                                    />
                                }
                                label="Flash on Update"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={preferences.popupDelete}
                                        onChange={handleChange}
                                        name="popupDelete"
                                    />
                                }
                                label="Popup Notification on Delete"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={preferences.darkMode}
                                        onChange={handleChange}
                                        name="darkMode"
                                    />
                                }
                                label="Dark Mode"
                            />
                        </FormGroup>
                        <FormLabel component="legend">
                            Favorite Team Preferences
                        </FormLabel>
                        <FormGroup sx={{pt: 2}}>
                            <TextField
                                label="Favorite Team (Abbrev.)"
                                name="favoriteTeam"
                                value={preferences.favoriteTeam}
                                onChange={handleChangeValue}
                                onBlur={handleBlurUppercase("favoriteTeam")}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={preferences.favoriteTeamOnly}
                                        onChange={handleChange}
                                        name="favoriteTeamOnly"
                                    />
                                }
                                label="Show Favorite Team Only"
                            />
                        </FormGroup>
                    </FormControl>
                </Box>
            </Modal>
        </div>
    );
}
